import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { apiConstants } from '../_constants';
import { subscriptionsService } from '../_services/subscriptions.service';
import './subscription.css';

export const SubscriptionModal = ({ showModal, setShowModal, data, subscriptionData, type }) => {
  const modalRef = useRef(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [subscription, setSubscription] = useState({});

  useEffect(() => {
    if (showPaymentModal) {
      const user = JSON.parse(localStorage.getItem('user'));
      callRazorPayment(subscription?._id, user.first_name, user.phone, user.email);
    }
  }, [showPaymentModal]);

  const onAddSubscription = async () => {
    console.log(subscriptionData, 'onAddSubscription', data);
    //to get current user
    let user = JSON.parse(localStorage.getItem('user'));
    // calculating the expiry date by subscription duration
    let currentDate = moment(); // get the current date
    // calculate the date by subscription duration days from now
    let futureDate = currentDate.add(subscriptionData?.duration, 'days');
    let expiry_at = moment(futureDate).valueOf();
    let subscription = {};
    subscription.payment_status = 0;
    subscription.user_id = user?._id;
    subscription.subscription_id = subscriptionData?._id;
    if (type == 'Course') {
      subscription.course_id = data?.course_id;
    } else {
      subscription.series_id = data._id;
    }
    subscription.expiry_date = expiry_at;
    if (data?.subscriptions_id) {
      subscription._id = data?.subscriptions_id;
    }
    console.log('_id of undefined', subscription);

    subscriptionsService.subscriptionsAdd(subscription).then(
      (res) => {
        console.log('subscriptionsAdd----', res?.data._id);
        localStorage.setItem(
          'payment_redirection',
          JSON.stringify({ type: type, course_id: data?.course_id, mock_id: data?._id }),
        );
        setShowPaymentModal(true);
        setSubscription(res.data);
        // setIsPaymentModal({
        //   modal: true,
        //   subscriptions: res?.data ? res.data : {},
        //   amount: data?.subscription?.amount,
        // });

        //   setIsSubscribeModal({ data: {}, modal: false });
      },
      (err) => {
        if (err == 'Your Account has been deactivated') {
          console.log(err, 'this is err');
          // setError(err);
          // setLogoutVisible(true);
        }
      },
    );
  };

  const callRazorPayment = (subscription_id, name, phone, email) => {
    const subData = {
      _id: subscription_id.toString(),
      currency: 'INR',
    };
    subscriptionsService.getRazorPaySubscriptionIDMobile(subData).then(
      (res) => {
        console.log('getRazorPaySubscriptionIDMobile', res);
        const options = {
          // eslint-disable-next-line no-undef
          key: process.env.RAZOPAY_KEY || 'rzp_live_lQ5mj702wUOjD7', // Fallback added for safety
          amount: res.data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: res.data.currency,
          name: 'Edraak',
          description: 'Subscription confirm',
          image: '/Group.png',
          order_id: res.data.id, //Pass the `id` obtained in the response of Step 1
          handler: function (response) {
            // Verify payment on the backend
            fetch(apiConstants.apiUrl + '/razorpaysuccess', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.success) {
                  // Direct the top window to success page, which also triggers the mobile app WebView
                  window.location.href = '/hi_payment_success/' + data.order_id;
                } else {
                  window.location.href = '/hi_payment_failed';
                }
              })
              .catch(() => {
                window.location.href = '/hi_payment_failed';
              });
          },
          modal: {
            ondismiss: function () {
              window.location.href = '/hi_payment_failed';
            },
          },
          prefill: {
            name: name,
            email: email,
            contact: phone,
          },
          readonly: { email: true, contact: true },
          theme: {
            color: '#283593',
          },
        };
        let rzp1 = new window.Razorpay(options); // to open razorpay window using options
        rzp1.open();
        rzp1.on('payment.failed', function (response) {
          console.error(response.error.reason);
          window.location.href = '/hi_payment_failed';
        });
      },
      () => {
        console.log('Something went wrong');
      },
    );
  };

  const handleModalClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowModal(false);
    }
  };
  const image =
    type == 'course'
      ? data?.course_image
        ? apiConstants.imgUrl + data?.course_image
        : '/img/course_dummy.png'
      : data?.image
        ? apiConstants.imgUrl + data?.image
        : '/img/course_dummy.png';
  console.log(type, 'this is data', data);
  return (
    <div
      className={'modal ' + (showModal ? 'show' : '')}
      id='myModal'
      onClick={(e) => {
        handleModalClick(e);
      }}
      ref={modalRef}
    >
      <div className='modal-content'>
        <span
          className='close'
          onClick={() => {
            setShowModal(false);
          }}
        >
          &times;
        </span>
        {!showPaymentModal && (
          <div>
            <div className='headercontainer mt-5 pb-2'>
              <div className='modaltitle'>
                Subscribe to {type == 'Course' ? 'Course' : 'Mock Test'}
              </div>
              <div className='modalsubtitle'>More questions. Better learning.</div>
            </div>
            <div className='coursedetailscontainer'>
              <img src={image} className='subscriptioncourseimg' />
              <div className='subscriptioncoursename'>{data?.course_name}</div>
              <div className='d-flex justify-content-center'>
                <div className='pricelabel'>
                  ₹{subscriptionData?.amount} for {subscriptionData?.duration} Days
                </div>
              </div>
            </div>
            <div className='actionbtncontainer'>
              <div className='makepaymentbtn' onClick={() => onAddSubscription()}>
                Make Payment
              </div>
              <div
                className='laterbtn'
                onClick={() => {
                  setShowModal(false);
                }}
              >
                Maybe Later
              </div>
            </div>
          </div>
        )}
        {showPaymentModal && (
          <div style={{ marginTop: '100px' }}>
            <img
              src='/img/Loadingicon.gif'
              style={{
                display: 'block',
                maxWidth: '100px',
                widht: '100%',
                margin: '0 auto',
              }}
            />
            <h2 style={{ textAlign: 'center' }}>Payment gateway loading ...</h2>
          </div>
        )}
      </div>
    </div>
  );
};
